import State from '../interfaces/states/State';

export const userId$ = (state: State): string => state.mapField.userId;

export const isError$ = (state: State): boolean => state.mapField.isError;

export const isLoading$ = (state: State): boolean => state.mapField.isLoading;

export const mapFieldsById$ = (state: State): any => state.mapField.mapFieldsById;

export const fieldId$ = (state: State): number => state.mapField.fieldId;

export const isFieldOrderLoaded$ = (state: State): boolean => !!mapFieldsById$(state)[fieldId$(state)];
